import { colors } from '../../colors';
var threeTile = {
  borderColor: colors.overcast,
  headingColor: colors.black,
  paraColor: colors.black,
  subHeadingColor: colors.dirtyBlue,
  bgColor: colors.paleGrey,
  ctaColor: colors.dirtyBlue,
  textColorDark: colors.black,
  textColorLight: colors.white,
  cardBgColorVariationC: colors.white
};
export default threeTile;